/* eslint-disable */
export default {
  createLog: 'Criar log',
  creating: 'Criando',
  save: 'Salvar',
  saving: 'Salvando',
  saved: 'Salvo',
  view: 'Exibir',
  creatingFailed: 'Falha ao criar.',
  savingFailed: 'Falha ao salvar.',
} as const;

// @key: @#@"createLog"@#@ @source: @#@"Create Log"@#@
// @key: @#@"creating"@#@ @source: @#@"Creating"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
// @key: @#@"saving"@#@ @source: @#@"Saving"@#@
// @key: @#@"saved"@#@ @source: @#@"Saved"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"creatingFailed"@#@ @source: @#@"Creating failed."@#@
// @key: @#@"savingFailed"@#@ @source: @#@"Saving failed."@#@
